import { FormConfig } from 'components/common/form/FormConfig';
import { BeaconType } from 'core/advertiser/BeaconConnection';
import { useMemo } from 'react';
import { validateEmpty } from 'utils/ValidateUtils';
import i18n from 'i18n';

export const useTenMaxBeaconFields = (beaconType: BeaconType) => {
  const fields = useMemo(() => {
    if (beaconType !== BeaconType.TENMAX_BEACON) {
      return [];
    }

    return new FormConfig.FieldsBuilder()
      .addFormikInput({
        label: i18n.t('beaconConnectionList.labels.tenMaxBeaconName'),
        name: 'name',
        validate: validateEmpty
      })
      .build();
  }, [beaconType]);

  return fields;
};
